import posthog from "posthog-js";

/**
 * Utility functions for PostHog analytics
 */

/**
 * Track a custom event
 * @param eventName - Name of the event to track
 * @param properties - Optional properties to attach to the event
 */
export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>,
) {
  if (typeof window !== "undefined") {
    posthog.capture(eventName, properties);
  }
}

/**
 * Identify a user with PostHog
 * @param userId - Unique identifier for the user
 * @param properties - Optional user properties
 */
export function identifyUser(
  userId: string,
  properties?: Record<string, unknown>,
) {
  if (typeof window !== "undefined") {
    posthog.identify(userId, properties);
  }
}

/**
 * Reset PostHog session (useful for logout)
 */
export function resetAnalytics() {
  if (typeof window !== "undefined") {
    posthog.reset();
  }
}
